const originHeaders = [
  { text: 'Tên học sinh', value: 'student', width: '250px' },
  { text: 'Lớp', value: 'class', width: '100px' },
  { text: 'Số điện thoại liên lạc', value: 'phone', width: '150px' },
  { text: 'Hình thức xe đưa đón', value: 'type', width: '150px' },
  { text: 'Xe tuyến', value: 'buses', width: '80px' }
  // driver headers (2 columns)
  // head-teacher headers (2 columns)
  // action column (1 column)
]

const driverHeaders = [{ text: 'GV phụ trách', value: 'driver', width: '150px' }]

const headTeacherHeaders = [{ text: 'GV chủ nhiệm', value: 'headTeacher', width: '150px' }]

const actionColumn = { text: 'Thao tác', value: 'action', align: 'right', width: '80px' }

const getTableHeaders = ({ isDriver = false, isHeadTeacher = false }) => {
  if (isDriver) return [...originHeaders, ...headTeacherHeaders, actionColumn]
  if (isHeadTeacher) return [...originHeaders, ...driverHeaders, actionColumn]
  return [...originHeaders, ...driverHeaders, ...headTeacherHeaders, actionColumn]
}

export { getTableHeaders }
